(function () {
  class ProductFaqs {
    constructor(section) {
      this.section = section;
      this.list = section.querySelector('[data-product-faq-list]');
      this.metafieldSource = section.querySelector('[data-product-faq-metafield]');
      this.staticSource = section.querySelector('[data-product-faq-static]');
      this.allowMultiple = section.dataset.allowMultiple === 'true';
      this.openFirst = section.dataset.openFirst === 'true';
      this.itemIndex = 0;

      if (!this.list) return;

      this.renderItems();
      this.bindItems();
      this.finalizeInitialState();
    }

    renderItems() {
      this.renderMetafieldItems();
      this.renderStaticItems();
    }

    renderMetafieldItems() {
      if (!this.metafieldSource) return;

      const headings = Array.from(this.metafieldSource.querySelectorAll('h1,h2,h3,h4,h5,h6'));
      headings.forEach((heading) => {
        const question = heading.textContent.trim();
        if (!question) return;

        const answer = document.createElement('div');
        let next = heading.nextElementSibling;
        while (next && !/^H[1-6]$/.test(next.tagName)) {
          answer.appendChild(next.cloneNode(true));
          next = next.nextElementSibling;
        }

        if (!answer.childElementCount && !answer.textContent.trim()) return;
        this.list.appendChild(this.createItem(question, answer.innerHTML, 'dynamic'));
      });
    }

    renderStaticItems() {
      if (!this.staticSource) return;

      Array.from(this.staticSource.querySelectorAll('[data-product-faq-static-item]')).forEach((sourceItem) => {
        const question = sourceItem.querySelector('[data-product-faq-static-question]')?.textContent.trim();
        const answer = sourceItem.querySelector('[data-product-faq-static-answer]')?.innerHTML.trim();
        if (!question || !answer) return;
        this.list.appendChild(this.createItem(question, answer, 'static'));
      });
    }

    createItem(question, answerHtml, source) {
      const item = document.createElement('div');
      const index = this.itemIndex++;
      const buttonId = `${this.section.id}-faq-button-${index}`;
      const panelId = `${this.section.id}-faq-panel-${index}`;

      item.className = 'product-faqs__item';
      item.dataset.productFaqItem = '';
      item.dataset.source = source;
      item.innerHTML = `
        <button class="product-faqs__question" type="button" id="${buttonId}" aria-expanded="false" aria-controls="${panelId}" data-product-faq-toggle>
          <span class="product-faqs__question-text"></span>
          <span class="product-faqs__icon" aria-hidden="true"></span>
        </button>
        <div class="product-faqs__panel" id="${panelId}" role="region" aria-labelledby="${buttonId}" data-product-faq-panel>
          <div class="product-faqs__answer"></div>
        </div>
      `;

      item.querySelector('.product-faqs__question-text').textContent = question;
      item.querySelector('.product-faqs__answer').innerHTML = answerHtml;
      return item;
    }

    bindItems() {
      this.items = Array.from(this.list.querySelectorAll('[data-product-faq-item]'));
      this.items.forEach((item) => {
        item.querySelector('[data-product-faq-toggle]')?.addEventListener('click', () => this.toggleItem(item));
      });
    }

    finalizeInitialState() {
      if (!this.items.length) {
        this.section.classList.add('is-empty');
        return;
      }

      this.section.classList.remove('is-empty');
      if (this.openFirst) this.openItem(this.items[0], false);
    }

    toggleItem(item) {
      if (item.classList.contains('is-open')) {
        this.closeItem(item);
      } else {
        this.openItem(item, true);
      }
    }

    openItem(item, animate) {
      if (!this.allowMultiple) {
        this.items.forEach((otherItem) => {
          if (otherItem !== item) this.closeItem(otherItem);
        });
      }

      const button = item.querySelector('[data-product-faq-toggle]');
      const panel = item.querySelector('[data-product-faq-panel]');
      if (!button || !panel) return;

      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');

      if (!animate) {
        panel.style.height = 'auto';
        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;
      window.setTimeout(() => {
        if (item.classList.contains('is-open')) panel.style.height = 'auto';
      }, this.getDuration());
    }

    closeItem(item) {
      const button = item.querySelector('[data-product-faq-toggle]');
      const panel = item.querySelector('[data-product-faq-panel]');
      if (!button || !panel || !item.classList.contains('is-open')) return;

      panel.style.height = `${panel.scrollHeight}px`;
      panel.offsetHeight;
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      panel.style.height = '0px';
    }

    getDuration() {
      const duration = window.getComputedStyle(this.section).getPropertyValue('--pf-duration').trim();
      if (duration.endsWith('ms')) return Number.parseFloat(duration) || 320;
      if (duration.endsWith('s')) return (Number.parseFloat(duration) || 0.32) * 1000;
      return 320;
    }
  }

  function initProductFaqs(scope) {
    (scope || document).querySelectorAll('[data-product-faqs]').forEach((section) => {
      if (section.dataset.productFaqsReady === 'true') return;
      section.dataset.productFaqsReady = 'true';
      new ProductFaqs(section);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initProductFaqs(document));
  document.addEventListener('shopify:section:load', (event) => initProductFaqs(event.target));
})();
